

const SpHighlight = ({children, className, ...rest}) => {
    return <span className={`sp-highlight ${className}`} {...rest}>{children}</span>
}

export default SpHighlight;